<table class="adminTable">
  <!--Table head-->
  <thead>
    <tr>
      <!-- Action Links Column -->
      <th></th>

      <th class="sortable-header" (click)="onSetSortClick('title')">
        Listing

        <span *ngIf="sort === 'title'">
          <i *ngIf="!sortDescending" class="fa fa-sort-amount-asc" aria-hidden="true"></i>
          <i *ngIf="sortDescending" class="fa fa-sort-amount-desc" aria-hidden="true"></i>
        </span>
      </th>

      <th *ngIf="showEmailColumn" class="sortable-header" (click)="onSetSortClick('emailAddress')">
        Email Address

        <span *ngIf="sort === 'emailAddress'">
          <i *ngIf="!sortDescending" class="fa fa-sort-amount-asc" aria-hidden="true"></i>
          <i *ngIf="sortDescending" class="fa fa-sort-amount-desc" aria-hidden="true"></i>
        </span>
      </th>

      <th id="check-in-event-grid-name-header" class="sortable-header" title="Computed columns cannot be sorted." >Name</th>

      <th class="sortable-header" (click)="onSetSortClick('mobilePhone')">
        Mobile Phone

        <span *ngIf="sort === 'mobilePhone'">
          <i *ngIf="!sortDescending" class="fa fa-sort-amount-asc" aria-hidden="true"></i>
          <i *ngIf="sortDescending" class="fa fa-sort-amount-desc" aria-hidden="true"></i>
        </span>
      </th>

      <th *ngIf="isAdmin" class="sortable-header" (click)="onSetSortClick('reservationId')">
        Reservation ID

        <span *ngIf="sort === 'reservationId'">
          <i *ngIf="!sortDescending" class="fa fa-sort-amount-asc" aria-hidden="true"></i>
          <i *ngIf="sortDescending" class="fa fa-sort-amount-desc" aria-hidden="true"></i>
        </span>
      </th>

      <th class="sortable-header" (click)="onSetSortClick('eventType')">
        Event Type

        <span *ngIf="sort === 'eventType'">
          <i *ngIf="!sortDescending" class="fa fa-sort-amount-asc" aria-hidden="true"></i>
          <i *ngIf="sortDescending" class="fa fa-sort-amount-desc" aria-hidden="true"></i>
        </span>
      </th>

      <th class="sortable-header" (click)="onSetSortClick('timestamp')">
        Timestamp

        <span *ngIf="sort === 'timestamp'">
          <i *ngIf="!sortDescending" class="fa fa-sort-amount-asc" aria-hidden="true"></i>
          <i *ngIf="sortDescending" class="fa fa-sort-amount-desc" aria-hidden="true"></i>
        </span>
      </th>

      <th *ngIf="isAdmin && showComments" class="sortable-header" (click)="onSetSortClick('comments')">
        Comments

        <span *ngIf="sort === 'comments'">
          <i *ngIf="!sortDescending" class="fa fa-sort-amount-asc" aria-hidden="true"></i>
          <i *ngIf="sortDescending" class="fa fa-sort-amount-desc" aria-hidden="true"></i>
        </span>
      </th>

      <!-- PK of CheckIn table -->
      <th *ngIf="isAdmin" class="sortable-header" (click)="onSetSortClick('checkInId')">
        CheckIn ID

        <span *ngIf="sort === 'checkInId'">
          <i *ngIf="!sortDescending" class="fa fa-sort-amount-asc" aria-hidden="true"></i>
          <i *ngIf="sortDescending" class="fa fa-sort-amount-desc" aria-hidden="true"></i>
        </span>
      </th>

      <!-- PK of CheckInOutEvent table -->
      <th *ngIf="isAdmin" class="sortable-header" (click)="onSetSortClick('Id')">
        CheckInOut Event ID

        <span *ngIf="sort === 'id'">
          <i *ngIf="!sortDescending" class="fa fa-sort-amount-asc" aria-hidden="true"></i>
          <i *ngIf="sortDescending" class="fa fa-sort-amount-desc" aria-hidden="true"></i>
        </span>
      </th>
    </tr>
  </thead>
  <!--Table head-->
  <!--Table body-->
  <tbody *ngIf="rows && !retrieving">
    <tr (click)="onSingleClick($event, r)" (dblclick)="onDoubleClick($event, r)" *ngFor="let r of rows">
      <!-- Action Links Column -->
      <td>
        <!-- No Action Components At This Time -->
      </td>

      <td>
        <div (click)="onSingleClick(r)">
          {{ r.title }}
          <link-to-new-admin-listing [listingId]="r.listingId"></link-to-new-admin-listing>
        </div>
      </td>

      <td *ngIf="showEmailColumn">
        <div class="email-cell" (click)="onSingleClick(r)">
          {{ r.emailAddress }}
          <!-- <link-to-user-account-detail [userAccountId]="r.userAccountId"></link-to-user-account-detail> -->
        </div>
      </td>

      <td>
        <div (click)="onSingleClick(r)">
          {{ r.fullName }}
          <link-to-user-account-detail [openInNewTab]="true" [userAccountId]="r.userAccountId"></link-to-user-account-detail>
        </div>
      </td>

      <td>
        <div class="email-cell" (click)="onSingleClick(r)">
          {{ r.mobilePhone }}
          <!-- <link-to-user-account-detail [userAccountId]="r.userAccountId"></link-to-user-account-detail> -->
        </div>
      </td>

      <td *ngIf="isAdmin">
        <div (click)="onSingleClick(r)">
          {{ r.reservationId }} <link-to-booking-detail [bookingId]="r.bookingId"></link-to-booking-detail>
        </div>
      </td>

      <td>
        <div (click)="onSingleClick(r)">
          {{ r.eventType }}
        </div>
      </td>

      <td>
        <div (click)="onSingleClick(r)">
          <div class="date-cell-display">
            <!-- https://angular.io/api/common/DatePipe -->
            {{ r.timestamp | date: "EEE, MMM d, y, h:mm a":"offset" }}
          </div>
        </div>
      </td>

      <td *ngIf="isAdmin && showComments">
        <div (click)="onSingleClick(r)">
          {{ r.comments }}
        </div>
      </td>

      <td *ngIf="isAdmin">
        <div (click)="onSingleClick(r)">
          {{ r.checkInId }}
        </div>
      </td>

      <td *ngIf="isAdmin">
        <div (click)="onSingleClick(r)">
          {{ r.id }}
        </div>
      </td>
    </tr>
  </tbody>
  <!--Table body-->
</table>
